import React from 'react';
import { useTranslation } from 'react-i18next';
import { SingleSelect } from '@unmind/design-system';

interface DurationDropdownProps {
  duration: number;
  onSelect(field: string, value: number): void;
}

export const DurationDropdown = ({
  duration,
  onSelect,
}: DurationDropdownProps) => {
  const { t: translate } = useTranslation('shared');

  const durationOptions = () => {
    const durations = [10, 15, 30, 60];

    return durations.map(length => ({
      label: translate('add_to_calendar.duration_dropdown.options', {
        length: length.toString(),
      }),
      value: length,
    }));
  };

  return (
    <SingleSelect
      id="duration-select"
      placeholder={translate('add_to_calendar.duration_dropdown.placeholder')}
      options={durationOptions()}
      selectedValue={duration}
      onChange={(value: number) => onSelect('duration', value)}
      aria-label={translate(
        'add_to_calendar.duration_dropdown.accessibility_label',
        { value: duration },
      )}
    />
  );
};
